import doneImage from "/images/onboarding/done_onboarding.svg";
import { useAppDispatch, useAppSelector } from "../../../stores/hooks/hooks";
import { useNavigate } from "react-router";
import { RevButton } from "@revmatics/catalyst";
import { completeOnboardingThunk } from "../../../stores/thunks/brandThunk";
import { useState } from "react";

export const Step6_Done = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [isNavigating, setIsNavigating] = useState(false);

  const { currentBrand } = useAppSelector((state) => ({
    currentBrand: state.userAuth.currentBrand,
  }));

  const destinationPath = "/personas";

  const handleNavigation = (path: string) => {
    setIsNavigating(true);

    if (currentBrand) {
      dispatch(completeOnboardingThunk(currentBrand.toString()))
        .unwrap()
        .catch((error) => {
          console.error(
            "Could not complete onboarding (but navigating anyway):",
            error,
          );
        })
        .finally(() => {
          navigate(path, { replace: true });
        });
    } else {
      console.error(
        "Could not complete onboarding: No currentBrand ID found in state.",
      );
      navigate(path, { replace: true });
    }
  };

  return (
    <div className="w-full h-full flex items-center justify-center mt-28">
      <div className="flex flex-row items-center justify-center gap-12 text-left">
        <img src={doneImage} alt="Setup Complete" className="max-w-sm" />
        <div className="flex flex-col max-w-md">
          <h3 className="typography-h4 mb-2">You are all set!</h3>
          <p className="typography-body-md text-monochrome-600 mb-6">
            Head over to the platform to finish setting up.
          </p>
          <RevButton
            text="Continue to Platform"
            displayAs="button"
            handleClick={() => handleNavigation(destinationPath)}
            className="w-fit"
            buttonSize="medium"
            isLoading={isNavigating}
          />
        </div>
      </div>
    </div>
  );
};
